<template>
    <div>
        <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <span 
                    :style="{color: $store.state.authInfo.alertBox.title == 'message.warning' ? 'orange' : 
                    $store.state.authInfo.alertBox.title == 'Error' ? 'red' : 'blue'}">
                    {{$store.state.authInfo.alertBox.title}}
                </span>
                
            </p>
        </header>
        
        <section class="modal-card-body" style="text-align: center;">
                
            <div style="width: 80%; margin: 0 auto;">
                <p style="font-weight: bold; font-size: 1.5em;" v-html="$store.state.authInfo.alertBox.message">
                
            </p>    
            <div style="height: 20px;">
                    &nbsp;
            </div>
            <div style="width: 100%; text-align: center;">
                <a @click="$store.state.authInfo.alertBox.show = false" 
                class="button is-medium is-primary">OK</a>
            </div>
            
            </div>    
            
        </section>

        </div>
    </div>
    
</template>

<script>
    export default {
        data() {
            return {
                
            }
        },
        methods: {
        
        }
    }
</script>

<style scoped>

    .container {
        width: 30%;
        padding: 20px;
        box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
        background-color: #fff; 
        margin: auto;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        height: 400px;
    }


/* Change styles for span and cancel button on extra small screens */
@media screen and (max-width: 1024px) {
    .container {
      width: 80%;
    }
    img {
      width: 70%;
    }
}

@media screen and (max-width: 300px) {
    
}

</style>



// WEBPACK FOOTER //
// src/components/Alert/Index.vue